import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import EditEducationModal from "./EditEducationModal";
import EditIcon from "../../../../assets/icons/edit-2.svg";
import AddEducation from "./AddEducation";
import { useQuery } from "react-query";
import { FaGraduationCap } from "react-icons/fa";
import moment from "moment";
import { useCustomToast } from "../../../../components/customtoast/CustomToastProvider";
import { profile } from "../../../../api/profile";

function Education({ refetchStatus, educations, refetchEducation }) {
  const { t } = useTranslation();
  const customToast = useCustomToast();
  const [openEducationModal, setOpenEducationModal] = useState(false);
  const [addEducationModal, setAddEducationModal] = useState(false);
  const [data, setData] = useState(educations?.data[0]);
  const { isLoading, data: institutions } = useQuery(
    "get-institution",
    profile.getInstitutionsv2
  );

  return (
    <div className="mb-10">
      <div className="mb-2">
        <div className="font-semibold text-xl text:darkBlue justify-between flex items-center gap-x-24 mb-6">
          {t('education')}
          <div
            className="cursor-pointer bi bi-plus-circle border border-primary text-primary p-2 rounded-lg text-base font-semibold"
            onClick={() => setAddEducationModal(true)}
            data-testid="add-edu"
          >
            &nbsp;{t('add-new-education')}
          </div>
        </div>
        <div>
          {openEducationModal && (
            <EditEducationModal
              closeModal={setOpenEducationModal}
              data={data}
              institutions={institutions}
              refetchEducation={refetchEducation}
              refetchStatus={refetchStatus}
            />
          )}
          {addEducationModal && (
            <AddEducation
              closeModal={setAddEducationModal}
              refetchEducation={refetchEducation}
              refetchStatus={refetchStatus}
            />
          )}
        </div>
        <div className="">
          {educations?.data.length === 0 && (
            <div className="text-center text-base font-medium text-lightGrey">
              {t('please-add-education')}
            </div>
          )}
          {educations?.data.map((education, id) => (
            <div key={id}>
              <div className="mb-3 flex justify-between items-center" key={education.id}>
                <div className="flex gap-x-4">
                  <div className="h-16 bg-gray-300 p-2 flex justify-start rounded">
                    <FaGraduationCap className="text-[3rem]" />
                  </div>
                  <div className="g">
                    <div className="font-medium text-xl text-darkBlue">
                      {education?.institution?.name}
                    </div>
                    <div className="font-normal text-lg">
                      {education.degree?.name}, {education.course?.title}
                    </div>
                    <div className="font-normal text-lg">
                      <span>{moment(education.start_date).format("yyy")}</span> - 
                      <span>{moment(education.end_date).format("yyy")}</span>
                    </div>
                    <div className="font-normal text-base">
                      <span>{t('grade')}</span>: <span>{education.class_of_degree?.name}</span>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end items-center gap-x-4">
                  <div
                    onClick={() => {
                      setData(education);
                      setOpenEducationModal(true);
                    }}
                    className="cursor-pointer"
                  >
                    <img src={EditIcon} alt="" />
                  </div>
                </div>
              </div>
              <hr className="py-4" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Education;
